import { render, staticRenderFns } from "./UploadFrequencyCheck.vue?vue&type=template&id=28be41b9&scoped=true&"
import script from "./UploadFrequencyCheck.vue?vue&type=script&lang=js&"
export * from "./UploadFrequencyCheck.vue?vue&type=script&lang=js&"
import style0 from "./UploadFrequencyCheck.vue?vue&type=style&index=0&id=28be41b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28be41b9",
  null
  
)

export default component.exports